import { requireAuth } from "@/router/helpers";

const AdminRoutes = [
  {
    path: "/admin/notifications",
    name: "AdminDeviceNotificationIndex",
    component: () => import("../pages/admin/Index"),
    beforeEnter: requireAuth,
    // // redirect: '/dashboard',
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/admin/notifications/add",
    name: "AdminNotificationCreate",
    components: {
      default: () => import("../pages/admin/Index"),
      panel: () => import("../pages/admin/AddEdit"),
    },
    // redirect: '/dashboard',
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
      openPanel: true,
    },
  },
  {
    path: "/admin/notifications/:id/edit",
    name: "AdminNotificationEdit",
    // // redirect: '/dashboard',
    components: {
      default: () => import("../pages/admin/Index"),
      panel: () => import("../pages/admin/AddEdit"),
    },
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
      openPanel: true,
    },
  },
];

export default [...AdminRoutes];
